import { getDefaultContent } from "../logic";
var useCalloutContent = function useCalloutContent(_ref) {
  var title = _ref.title,
    severity = _ref.severity,
    size = _ref.size,
    icon = _ref.icon;
  var _getDefaultContent = getDefaultContent(severity),
    defaultTitle = _getDefaultContent.title,
    titleColor = _getDefaultContent.titleColor,
    defaultIcon = _getDefaultContent.icon,
    iconColor = _getDefaultContent.iconColor,
    spinnerColor = _getDefaultContent.spinnerColor;
  var isCompactLayout = size === "compact" || size === "blockCompact";
  var iconSize = "1rem";
  var titleToDisplay = title || defaultTitle;
  var iconToDisplay = icon || defaultIcon;
  return {
    titleToDisplay: titleToDisplay,
    titleColor: titleColor,
    iconToDisplay: iconToDisplay,
    iconColor: iconColor,
    spinnerColor: spinnerColor,
    iconSize: iconSize,
    isCompactLayout: isCompactLayout
  };
};
export default useCalloutContent;